/**
 * Prioridad del balanceo de turnos frente a la cobertura de pending needs.
 * Solo aplica cuando el balanceo de turnos está activo; si no, el payload va a false.
 */

export function isBalanceShiftsHighPriorityVisible(magicPlan = {}) {
	return Boolean(magicPlan.balance_shifts_by_employee);
}

export function resolveBalanceShiftsHighPriority(magicPlan = {}) {
	return Boolean(
		magicPlan.balance_shifts_by_employee &&
			magicPlan.balance_shifts_by_employee_high_priority
	);
}

export function withBalanceShiftsByEmployee(magicPlan = {}, isOn) {
	const balanceOn = Boolean(isOn);

	return {
		...magicPlan,
		balance_shifts_by_employee: balanceOn,
		balance_shifts_by_employee_high_priority: balanceOn
			? Boolean(magicPlan.balance_shifts_by_employee_high_priority)
			: false,
	};
}
